export default __webpack_public_path__ + "static/media/background_md.654c93fb.svg";